import SogDropDownButtonItem from "@/shared/ui/types/SogDropDownButtonItem";

/** Mail-Arten, die manuell zu einer unbekannten Zulassung angelegt werden können. Erinnerungen entstehen nur aus einer gesendeten Anfrage. */
export const registrationInquiryMailTypeItems: SogDropDownButtonItem[] = [
  {id: "InsuranceCopy", text: "Versicherungsschein anfordern"},
  {id: "Urgent", text: "Dringend (Schadensfall)"},
  {id: "DoubleNumber", text: "Policennummer mehrfach"},
  {id: "ForeignPolicy", text: "Fremde Police"},
  {id: "InternalNumber", text: "Interne Nummer der Zulassungsstelle"},
];
